import { keyframes, css } from '@emotion/react'
import styled from '@emotion/styled'
import { Button } from '@mui/material'
import { motion } from 'framer-motion'

export const formVariants = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.2,
      // ease: 'easeInOut',
      // duration: 1,
    },
  },
}

export const fieldVariants = {
  hidden: {
    opacity: 0,
    y: 50,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      ease: 'easeInOut',
      duration: 1,
    },
  },
}

const gradientAnimation = keyframes`
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
`

const centerFlex = css`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const LoginWrapper = styled.div`
  background-color: #eee;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px;

  * {
    box-sizing: border-box;
  }
`

export const Modal = styled(motion.div)`
  background-color: #fff;
  max-width: 1000px;
  width: 100%;
  display: flex;
  height: 600px;

  @media (max-width: 780px) {
    flex-direction: column;
    height: auto;
  }
`

export const ModalForm = styled.div`
  position: relative;
  padding: 60px;
  width: 400px;

  @media (min-width: 781px) {
    ${centerFlex}
  }

  @media (max-width: 780px) {
    width: 100%;
  }

  @media (max-width: 900px) {
    padding: 30px;
  }

  .claravine-logo {
    position: absolute;
    top: 60px;
    left: 60px;

    @media (max-width: 780px) {
      position: relative;
      top: 0;
      left: 0;
    }
  }

  .ConfirmResetPassword {
    flex: 1;
  }

  .ConfirmResetPassword .MuiOutlinedInput-input,
  .ResetPassword .MuiOutlinedInput-input {
    padding: 28px 15px;
  }
`

export const ModalPreview = styled.div`
  flex: 1;
  background-image:
    linear-gradient(130deg, #3d3393 0%, #2b76b9 37%, #2cacd1 65%, #35eb93 100%),
    linear-gradient(
      208.25deg,
      rgba(0, 194, 255, 0) 0%,
      rgba(64, 132, 153, 0.3) 48.07%,
      rgba(40, 95, 112, 0.6) 83.04%
    );
  animation: ${gradientAnimation} 5s ease infinite;
  background-size: 300% 300%;
  position: relative;
  display: flex;
  justify-content: center;
  max-width: 600px;
  width: 100%;
  overflow: hidden;
  padding: 50px;

  @media (max-width: 780px) {
    border-top-right-radius: 0;
    border-bottom-left-radius: 10px;
  }

  @media (max-width: 900px) {
    padding: 30px;
    max-width: 100%;
  }
`

export const PreviewBox = styled(motion.section)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;

  @media (max-width: 780px) {
    img {
      max-width: 100% !important;
    }
  }
`

export const PreviewContent = styled.section`
  color: #fff;
  margin-top: 290px;
  z-index: 1;
  display: flex;
  flex-direction: column;

  p {
    margin: 0;
    max-width: 443px;
    width: 100%;
  }

  h1 {
    line-height: 1.3;
  }
`

const artifactColors = ['#61DBD4', '#8FFFF9']

export const getRandomColor = () =>
  artifactColors[Math.floor(Math.random() * artifactColors.length)]

export const Artifacts = styled.div`
  svg path {
    fill: ${({ color }) => color};
  }
`

export const AnimatedButton = styled(Button)`
  position: relative;
  color: white;
  padding: 6px 16px;
  font-size: 14px;
  margin-top: 30px;
  background-color: #479f6b;

  &:hover: {
    background-color: #32784f;
  }
`
